import { monospaceFontFamily } from "src/providers/theme";
import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    root: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            flexWrap: "wrap",
            alignItems: "center",
        },
        "& .MuiInputAdornment-root": {
            height: "auto",
            maxHeight: "none",
            whiteSpace: "normal",
        },
        "& .MuiInputBase-input": {
            flex: "1 1 auto",
            minWidth: 80,
            width: "auto",
        },
    },
    startAdornment: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
    },
    chipsArea: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: theme.spacing(0.5),
    },
    chip: {
        fontFamily: monospaceFontFamily,
        fontSize: 12,
    },
    draftChip: {
        fontFamily: monospaceFontFamily,
        fontSize: 12,
        backgroundColor: theme.palette.action.selected,
    },
    searchIcon: {
        marginRight: theme.spacing(0.5),
    },
    list: {
        maxHeight: 360,
        overflowY: "auto",
    },
}));
